module.exports = __webpack_public_path__ + "media/images/login/login_t3-102e5c93550727808350c29d1392c4f2.gif";